import { useEffect } from 'react'
import { useToast } from '../contexts/ToastContext'

// 用于Redux操作的Toast Hook
export function useToastWithRedux() {
	const { showSuccess, showError, showWarning, showInfo } = useToast()

	// 处理Redux异步操作的结果
	const handleAsyncResult = (result, successMessage = 'Operation successful', errorMessage = 'Operation failed') => {
		if (result.meta?.requestStatus === 'fulfilled') {
			showSuccess(successMessage)
		} else if (result.meta?.requestStatus === 'rejected') {
			const errorMsg = result.payload || result.error?.message || errorMessage
			showError(errorMsg)
		}
	}

	// 处理登录结果
	const handleLoginResult = (result) => {
		if (result.meta?.requestStatus === 'fulfilled') {
			showSuccess('Login successful')
		} else if (result.meta?.requestStatus === 'rejected') {
			const errorMsg = result.payload || 'Login failed'
			showError(errorMsg)
		}
	}

	// 处理退出登录结果
	const handleLogoutResult = (result) => {
		if (result.meta?.requestStatus === 'fulfilled') {
			showSuccess('Logged out successfully')
		} else if (result.meta?.requestStatus === 'rejected') {
			showError('Logout failed')
		}
	}

	return {
		showSuccess,
		showError,
		showWarning,
		showInfo,
		handleAsyncResult,
		handleLoginResult,
		handleLogoutResult
	}
} 